export const homeIconSvg = (value: boolean, selected: string, disabled: string) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 46.974 40.464" id="iconMenu-icon-home">
		<path
			d="M22.79,46.464V32.183h9.395V46.464H43.928V27.422h7.046L27.487,6,4,27.422h7.046V46.464Z"
			transform="translate(-4 -6)"
			fill={value ? selected : disabled}
		/>
	</svg>
);
